import React, {useState, useEffect, useContext} from 'react'
import ReactPlayer from 'react-player'
import { useParams } from 'react-router-dom'
import {BsFillCheckCircleFill} from 'react-icons/bs'
import {AiOutlineLike} from 'react-icons/ai'
import { abbreviateNumber } from 'js-abbreviation-number'

import {fetchDataFromApi} from '../utils/api'
import {Context} from '../context/contextApi'
import SuggestionsVideos from './SuggestionsVideos'

const VideoDetails = () => {
  const [video, setVideo] = useState();
  const [relatedVideos, setRelatedVideos] = useState()
  const {id} = useParams()

  const {setLoading} = useContext(Context)

  useEffect ( ()=> {
    document.getElementById("root").classList.add("custom-h")
    fetchVideoDetails();
    relatedVideoDetails();
  }, [id] )

  const fetchVideoDetails = () => {
    
    setLoading(true)
    fetchDataFromApi(`video/details/?id=${id}`).then((res) => { 
      console.log(res)
      setVideo(res)
      setLoading(false)
    })
  }

  const relatedVideoDetails = () => {
    
    setLoading(true)
    fetchDataFromApi(`video/related-contents/?id=${id}`).then((res) => { 
      console.log(res)
      setRelatedVideos(res)
      setLoading(false)
    })
  }
  return (
    
    <div className="flex justify-center flex-row h-[calc(100%-56px)] bg-black">
      <div className="flex flex-col lg:flex-row w-full max-w-[1280px]">

        <div className="flex flex-col lg:w-[calc(100%-350px)] xl:w-[calc(100%-400px)] px-3 py-3 lg:py-6 overflow-y-auto">
          <div className="h-[200px] md:h-[400px] lg:h-[400px] xl:h-[550px] ml-[-16px] lg:ml-0 mr-[-16px] lg:mr-0">
            <ReactPlayer 
            url ={`https://youtube.com/watch?v=${id}`}
            controls 
            width="100%"
            height="100%"
            style={{ backgroundColor: "#000000"}}
            />
          </div>

          <div className="text-white font-bold text-sm md:text-xl mt-4 line-clamp-2">
            {video?.title}
          </div>

          <div className='flex justify-between flex-col md:flex-col mt-4'>
            <div className="flex">
              <div className="flex items-start">
                <div className="flex h-11 w-11 rounded-full overflow-hidden">
                  <img src={video?.author?.avatar[0]?.url} className="h-full w-full object-cover" alt="avatar" />
                </div>
              </div>

              <div className="flex flex-col ml-3">
                <div className="text-white text-md font-semibold flex items-center">
                  {video?.author?.title}
                  {video?.author?.badges[0]?.type === "VERIFIED_CHANNEL" && (
                <BsFillCheckCircleFill className="text-white/[0.5] text-[12px] ml-1" />
              )}
                </div>

                <div className='text-white/[0.7] text-sm'>
                  {video?.author?.stats?.subscribersText}
                </div>
              </div>
            </div>
            
            

          </div>



        </div>

        <div className="text-white flex flex-col py-6 px-4 overflow-y-auto lg:w-[350px] xl:w-[4--px]">

          {relatedVideos?.contents?.map( (item, index) => {
            
            if(item.type !=="video") return false 
            return (
              <SuggestionsVideos key={index} video={item?.video}/>

            )

            
          })}
        </div>

      </div>
    </div>
  )
}

export default VideoDetails